
/* injects from baggage-loader */

'use strict'

import StageBaseController from '../stage-base.controller';

import {
    scene1,
    scene2,
    puzzle,
    introBallons,
    tutorialBallons,
    dropSuccessBallons,
    dropFailBallons,
    feedbackTexts
} from './stage-one.const'

import { topLeftWithStatusBarPosition } from '_appRoot/index.const';
import { CharThumbs } from '_appRoot/index.const';

import gifAnimation from '_images/stages/stage-one/chroma-animation.gif';
import defaultSquare from '_images/stages/stage-one/gameplay/default.png';

// import ghostPng from '_images/ghost.png';

import { shuffle, findIndex, filter } from 'lodash';

export default class StageOneController extends StageBaseController {
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session) {
        'ngInject';
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 0);

        this.state = {
            step: 1
        }

        this.ballons = {
            ballon1: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: introBallons,
                position: topLeftWithStatusBarPosition
            },
            ballon2: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: tutorialBallons,
                position: topLeftWithStatusBarPosition
            },
            dropsuccess: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: dropSuccessBallons,
                position: topLeftWithStatusBarPosition
            },
            dropfail: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: dropFailBallons,
                position: topLeftWithStatusBarPosition
            }
        }

        this.scene1 = scene1;
        this.scene2 = scene2;

        this.gifAnimation = gifAnimation;

        // Gameplay
        this.model = {
            puzzle: [
                { id: 'p1', value: undefined, fail: null, success: null },
                { id: 'p2', value: undefined, fail: null, success: null },
                { id: 'p3', value: undefined, fail: null, success: null },
                { id: 'p4', value: undefined, fail: null, success: null },
                { id: 'p5', value: undefined, fail: null, success: null },
            ]
        };

        this.puzzle = shuffle(puzzle);
        this.defaultSquare = defaultSquare;
    }

    $onInit() {
        this.$timeout(() => {
            this.ballons.ballon1.visible = true;
        }, 800);
    }


    toGameplay() {
        this.state.step++;

        this.$timeout(() => {
            this.ballons.ballon2.visible = true;
        }, 800);


        document.querySelectorAll('.puzzle-part').forEach(ele => {
            ele.addEventListener('dragover', event => {
                this.$rootScope.$emit('chroma-pointer:trigger:moviment', event);
            });

            // ele.addEventListener('dragstart', function(event){
            //     let blank = document.createElement('img');
            //     blank.src = ghostPng;
            //     event.dataTransfer.setDragImage(blank, 0, 0);
            // });
        });
    }

    toScene2() {
        this.state.step++;
    }

    onCloseBallon1() {
        this.ballons.ballon1.visible = false;
        this.state.step++;

        // to next scene
        this.$timeout(() => {
            this.state.step++
        }, 2700);
    }

    onCloseBallon2() {
        this.ballons.ballon2.visible = false;
    }

    onScene1Finish() {
        this.state.step++;
    }

    onScene2Finish() {
        this.$timeout(this.$state.go.bind(this, 'main'), 1000);
    }

    onDropGamePlay($event, $data, part) {
        if ($data.id === part.id) {
            let index = findIndex(this.puzzle, { id: $data.id });

            part.value = $data;
            part.success = true;

            this.puzzle.splice(index, 1); //remove part puzzle from puzzle array

            let isIncomplete = filter(this.model.puzzle, { value: undefined }).length;

            isIncomplete ? this.onDropSuccessGamePlay() : super.finish(this.onFinish.bind(this));
        } else {
            this.onDropFailGamePlay();
            part.fail = true;
        }

        // remove classes for new animations
        this.$timeout(() => {
            this.model.puzzle.forEach(p => {
                p.fail = null;
                p.success = null;
            })
        }, 2000)
    }

    onDropSuccessGamePlay() {
        this.ballons.dropsuccess.visible = true;
    }

    onDropSuccessGamePlayFinish() {
        this.ballons.dropsuccess.visible = false;
    }

    onDropFailGamePlay() {
        this.ballons.dropfail.visible = true;
    }

    onDropFailGamePlayFinish() {
        this.ballons.dropfail.visible = false;
        super.onFinishFail();
    }

    onFinish() {
        this.$timeout(this.Dialog.showFeedback.bind(this, feedbackTexts, this.toScene2.bind(this)), 1300);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.controller.js